module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingplan-edit"
  }, [_c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingName', true)
  }, [_vm._m(0), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "attr": {
        maxlength: 50
      },
      "label": "",
      "placeholder": "请输入会议名称"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingName", $$v)
      },
      expression: "addNewOrEditData.meetingName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingSystem', true)
  }, [_c('common-select-multiple', {
    ref: "meetingSystem",
    attrs: {
      "tipCode": "8",
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "系统选择",
      "placeholder": "请选择（可多选）",
      "datas": _vm.baseDataRecords.MeetingSystem,
      "textKey": 'text',
      "valueKey": 'value'
    },
    model: {
      value: (_vm.addNewOrEditData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingSystem", $$v)
      },
      expression: "addNewOrEditData.meetingSystem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingModality', true)
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "是否网络会议",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.MeetingModality,
      "textKey": 'text',
      "valueKey": 'value'
    },
    model: {
      value: (_vm.addNewOrEditData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingModality", $$v)
      },
      expression: "addNewOrEditData.meetingModality"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingProp', true)
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "会议性质",
      "placeholder": "请选择",
      "datas": _vm.meetingPropAndTypeArrays.selectMeetingProp,
      "textKey": 'itemText',
      "valueKey": 'itemValue'
    },
    on: {
      "change": function($event) {
        return _vm.handleMeetingPropChange()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingProp", $$v)
      },
      expression: "addNewOrEditData.meetingProp"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'GSD'),
      expression: "meetingSystemType != 'GSD'"
    }],
    staticClass: "field-row",
    class: _vm.required('meetingType', _vm.meetingSystemType != 'GSD')
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "A1会议类型",
      "placeholder": "请选择",
      "datas": _vm.filterMeetingType,
      "textKey": 'itemText',
      "valueKey": 'itemValue'
    },
    on: {
      "change": _vm.handleMeetingTypeChange
    },
    model: {
      value: (_vm.addNewOrEditData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingType", $$v)
      },
      expression: "addNewOrEditData.meetingType"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.meetingType == '24' && _vm.isCEDepart()),
      expression: "addNewOrEditData.meetingType == '24' && isCEDepart()"
    }]
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('isGsd', _vm.addNewOrEditData.meetingType == '24' && _vm.isCEDepart())
  }, [_vm._v("是否为GSD"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('mt-radio', {
    staticClass: "radio",
    attrs: {
      "title": "",
      "options": _vm.isGsdOptions
    },
    model: {
      value: (_vm.addNewOrEditData.isGsd),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "isGsd", $$v)
      },
      expression: "addNewOrEditData.isGsd"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'A1'),
      expression: "meetingSystemType != 'A1'"
    }],
    staticClass: "field-row",
    class: _vm.required('meetingGsdType', _vm.meetingSystemType != 'A1')
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "GSD项目类型",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.MeetingGsdType,
      "textKey": 'text',
      "valueKey": 'value'
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingGsdType", $$v)
      },
      expression: "addNewOrEditData.meetingGsdType"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'A1'),
      expression: "meetingSystemType != 'A1'"
    }],
    staticClass: "field-row",
    class: _vm.required('meetingGsdSubType', _vm.meetingSystemType != 'A1')
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "GSD细类",
      "placeholder": "请选择",
      "datas": _vm.MeetingGsdSubTypes,
      "textKey": 'text',
      "valueKey": 'value'
    },
    model: {
      value: (_vm.addNewOrEditData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingGsdSubType", $$v)
      },
      expression: "addNewOrEditData.meetingGsdSubType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('departId', true)
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "部门",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.Depart,
      "textKey": 'departName',
      "valueKey": 'id'
    },
    on: {
      "change": _vm.handleDepartChange
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('medicalField', true)
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "Franchise/DA",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.MedicalField,
      "textKey": 'medicalFieldName',
      "valueKey": 'id'
    },
    on: {
      "change": _vm.resetRelativeFields
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('teamL4', true)
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "团队",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.Teams,
      "textKey": 'teamName',
      "valueKey": 'id'
    },
    on: {
      "change": _vm.resetRelativeFields
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广'),
      expression: "basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '推广'"
    }],
    staticClass: "field-row",
    class: _vm.required('treatmentArea', _vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广')
  }, [_c('common-select', {
    attrs: {
      "filterable": "",
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "治疗领域",
      "placeholder": "请选择",
      "datas": _vm.areaRelationObject[_vm.addNewOrEditData.meetingProp],
      "textKey": 'areaName',
      "valueKey": 'areaDbId'
    },
    on: {
      "change": function($event) {
        return _vm.handleAreaChange()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "treatmentArea", $$v)
      },
      expression: "addNewOrEditData.treatmentArea"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0),
      expression: "basedataGetName('MeetingProp',addNewOrEditData.meetingProp).indexOf('非推广') >= 0"
    }],
    staticClass: "field-row",
    class: _vm.required('diseaseArea', _vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0)
  }, [_c('common-select', {
    attrs: {
      "filterable": "",
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "疾病领域",
      "placeholder": "请选择",
      "datas": _vm.areaRelationObject[_vm.addNewOrEditData.meetingProp],
      "textKey": 'areaName',
      "valueKey": 'areaDbId'
    },
    on: {
      "change": function($event) {
        return _vm.handleAreaChange()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "diseaseArea", $$v)
      },
      expression: "addNewOrEditData.diseaseArea"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-title",
    class: _vm.required('productId', true)
  }, [_vm._v("产品(多选)"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('productId', true)
  }, [_c('common-select-multiple', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "title": "",
      "placeholder": "请选择",
      "datas": _vm.productArray,
      "textKey": 'productName',
      "valueKey": 'productDbId'
    },
    on: {
      "change": _vm.resetRelativeFields
    },
    model: {
      value: (_vm.addNewOrEditData.productId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "productId", $$v)
      },
      expression: "addNewOrEditData.productId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-title",
    class: _vm.required('companyStrategy', true)
  }, [_vm._v("公司战略(多选)"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('companyStrategy', true)
  }, [_c('common-select-multiple', {
    attrs: {
      "clearable": "",
      "title": "",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.CompanyStrategy,
      "textKey": 'text',
      "valueKey": 'value'
    },
    model: {
      value: (_vm.addNewOrEditData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "companyStrategy", $$v)
      },
      expression: "addNewOrEditData.companyStrategy"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-title",
    class: _vm.required('strategyKeynote', true)
  }, [_vm._v("策略重点(多选)"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('common-select-multiple', {
    ref: "strategy",
    attrs: {
      "filterable": "",
      "clearable": "",
      "title": "",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.filterStrategy,
      "includeDatas": [{
        'id': '999999',
        'productNameAndKeynote': '其他/不适用'
      }],
      "textKey": 'productNameAndKeynote',
      "valueKey": 'id'
    },
    model: {
      value: (_vm.addNewOrEditData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "strategyKeynote", $$v)
      },
      expression: "addNewOrEditData.strategyKeynote"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-title",
    class: _vm.required('medicalFieldResult', _vm.meetingSystemType != 'A1')
  }, [_vm._v("治疗领域业务结果(多选)"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('common-select-multiple', {
    ref: "domainResult",
    attrs: {
      "filterable": "",
      "clearable": "",
      "title": "",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.filterDomainResult,
      "textKey": 'productNameAndTreatAreaResult',
      "valueKey": 'id',
      "includeDatas": [{
        'id': '999999',
        'productNameAndTreatAreaResult': '其他'
      }]
    },
    model: {
      value: (_vm.addNewOrEditData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalFieldResult", $$v)
      },
      expression: "addNewOrEditData.medicalFieldResult"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0),
      expression: "addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0"
    }],
    staticClass: "field-title"
  }, [_vm._v("治疗领域业务结果（自定义描述）")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0),
      expression: "addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0"
    }],
    staticClass: "field-row"
  }, [_c('mt-field', {
    attrs: {
      "attr": {
        maxlength: 200
      },
      "placeholder": "请输入治疗领域业务结果自定义描述，最多可输入200字",
      "type": "textarea"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalFieldResultDes),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalFieldResultDes", $$v)
      },
      expression: "addNewOrEditData.medicalFieldResultDes"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingBeginDate', true)
  }, [_c('common-select-datetime', {
    attrs: {
      "required": "",
      "alignRight": "",
      "title": "会议开始日期",
      "placeholder": "请选择",
      "pickerOptions": _vm.startPickerOptions,
      "defaultDate": _vm.seasonStartDate,
      "minDate": _vm.seasonStartDate
    },
    model: {
      value: (_vm.addNewOrEditData.meetingBeginDate),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingBeginDate", $$v)
      },
      expression: "addNewOrEditData.meetingBeginDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingEndDate', true)
  }, [_c('common-select-datetime', {
    attrs: {
      "required": "",
      "alignRight": "",
      "title": "会议结束日期",
      "placeholder": "请选择",
      "pickerOptions": _vm.endPickerOptions,
      "defaultDate": _vm.seasonStartDate,
      "minDate": _vm.seasonStartDate
    },
    model: {
      value: (_vm.addNewOrEditData.meetingEndDate),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingEndDate", $$v)
      },
      expression: "addNewOrEditData.meetingEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingTimeInt', _vm.meetingSystemType != 'GSD')
  }, [_c('common-select', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "clearable": "",
      "alignRight": "",
      "title": "会议时段",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.MeetingTimeInt,
      "textKey": 'text',
      "valueKey": 'value'
    },
    model: {
      value: (_vm.addNewOrEditData.meetingTimeInt),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingTimeInt", $$v)
      },
      expression: "addNewOrEditData.meetingTimeInt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('country', _vm.meetingSystemType != 'GSD')
  }, [_c('common-select', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "clearable": "",
      "alignRight": "",
      "title": "国家",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.Country,
      "textKey": 'name',
      "valueKey": 'id'
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.addNewOrEditData.country),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "country", $$v)
      },
      expression: "addNewOrEditData.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('province', _vm.meetingSystemType != 'GSD')
  }, [_c('common-select', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "clearable": "",
      "alignRight": "",
      "title": "省份",
      "placeholder": "请先选择国家",
      "datas": _vm.remoteProvinceData,
      "textKey": 'name',
      "valueKey": 'id'
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.addNewOrEditData.province),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "province", $$v)
      },
      expression: "addNewOrEditData.province"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('city', _vm.meetingSystemType != 'GSD')
  }, [_c('common-select', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "clearable": "",
      "alignRight": "",
      "title": "城市",
      "placeholder": "请先选择省份",
      "datas": _vm.remoteCitiesData,
      "textKey": 'name',
      "valueKey": 'id'
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.cityName = _vm.getName(_vm.addNewOrEditData.city, _vm.remoteCitiesData, 'id', 'name');
        _vm.clearHospital()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.city),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "city", $$v)
      },
      expression: "addNewOrEditData.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('meetingPlace', _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0)
  }, [_vm._m(1), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "attr": {
        maxlength: 50
      },
      "placeholder": "请输入会议地点"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingPlace),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingPlace", $$v)
      },
      expression: "addNewOrEditData.meetingPlace"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'A1'),
      expression: "meetingSystemType != 'A1'"
    }]
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('recipientSocietyOrHospital', _vm.meetingSystemType != 'A1', true)
  }, [_c('common-select', {
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "alignRight": "",
      "title": "受赠方类型",
      "placeholder": "请选择",
      "datas": _vm.recipientSocietyOrHospitalOptions,
      "textKey": 'label',
      "valueKey": 'value'
    },
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '1'),
      expression: "meetingSystemType != 'A1' && recipientSocietyOrHospital === '1'"
    }],
    staticClass: "field-row",
    class: _vm.required('recipientSocietyStr', _vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '1')
  }, [_vm._m(2), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.recipientSocietyStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "recipientSocietyStr", $$v)
      },
      expression: "addNewOrEditData.recipientSocietyStr"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '2'),
      expression: "meetingSystemType != 'A1' && recipientSocietyOrHospital === '2'"
    }],
    staticClass: "field-row",
    class: _vm.required('universityStr', _vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '2')
  }, [_vm._m(3), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.universityStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "universityStr", $$v)
      },
      expression: "addNewOrEditData.universityStr"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '3'),
      expression: "meetingSystemType != 'A1' && recipientSocietyOrHospital === '3'"
    }],
    staticClass: "field-row",
    class: _vm.required('patientOrgStr', _vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '3')
  }, [_vm._m(4), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.patientOrgStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "patientOrgStr", $$v)
      },
      expression: "addNewOrEditData.patientOrgStr"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '4'),
      expression: "meetingSystemType != 'A1' && recipientSocietyOrHospital === '4'"
    }],
    staticClass: "field-row",
    class: _vm.required('otherStr', _vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital === '4')
  }, [_vm._m(5), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.otherStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "otherStr", $$v)
      },
      expression: "addNewOrEditData.otherStr"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && !_vm.isOneHospital()),
      expression: "(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !isOneHospital()"
    }]
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('moreThenOneHospital', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && !_vm.isOneHospital())
  }, [_vm._v("医院总数"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('mt-checklist', {
    staticClass: "radio",
    attrs: {
      "options": _vm.moreThenOneHospitalOptions
    },
    model: {
      value: (_vm.moreThenOneHospitalArray),
      callback: function($$v) {
        _vm.moreThenOneHospitalArray = $$v
      },
      expression: "moreThenOneHospitalArray"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0')),
      expression: "(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')"
    }],
    staticClass: "field-block more-tab-block"
  }, [_c('div', {
    staticClass: "more-tab",
    class: _vm.isOneHospital() ? 'full' : ''
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('hospitalLevelId', _vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0')
  }, [_c('common-select', {
    attrs: {
      "tipCode": "9",
      "required": _vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0',
      "clearable": "",
      "alignRight": "",
      "title": "医院层级",
      "placeholder": "请选择",
      "datas": _vm.filterHospitalLevel,
      "textKey": 'hospitalLevel',
      "valueKey": 'id'
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalLevelId", $$v)
      },
      expression: "addNewOrEditData.hospitalLevelId"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreThenOneHospital == 1 && !_vm.isOneHospital()),
      expression: "moreThenOneHospital == 1 && !isOneHospital()"
    }],
    staticClass: "field-row",
    class: _vm.required('hospitalCount', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && _vm.moreThenOneHospital == 1 && !_vm.isOneHospital())
  }, [_vm._m(6), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "label": "",
      "placeholder": "请输入医院数量",
      "type": "number",
      "attr": {
        min: 0
      }
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalCount", $$v)
      },
      expression: "addNewOrEditData.hospitalCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.moreThenOneHospital == 1 && !_vm.isOneHospital())),
      expression: "!(moreThenOneHospital == 1 && !isOneHospital())"
    }],
    staticClass: "field-row",
    class: _vm.required('hospitalId', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && !(_vm.moreThenOneHospital == 1 && !_vm.isOneHospital()))
  }, [_c('common-select-search', {
    attrs: {
      "required": (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && !(_vm.moreThenOneHospital == 1 && !_vm.isOneHospital()),
      "clearable": "",
      "alignRight": "",
      "title": "医院",
      "placeholder": (_vm.isOneHospital() && !_vm.addNewOrEditData.cityName) ? '请先选择城市' : '请输入',
      "datas": _vm.remoteHospitalData,
      "remote-method": _vm.handleHospitalFilter,
      "textKey": 'hospitalName',
      "valueKey": 'id'
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.hospitalName = _vm.getName(_vm.addNewOrEditData.hospitalId, _vm.remoteHospitalData, 'id', 'hospitalName')
      }
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalId", $$v)
      },
      expression: "addNewOrEditData.hospitalId"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreThenOneHospital == 1 && !_vm.isOneHospital()),
      expression: "moreThenOneHospital == 1 && !isOneHospital()"
    }],
    staticClass: "operate-add-remove"
  }, [_c('i', {
    staticClass: "iconfont icon-tianjia1",
    on: {
      "click": _vm.AddNewHospitalInfo
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreThenOneHospital == 1 && !_vm.isOneHospital() && _vm.addNewOrEditData.extendData.hospitalInfos.length > 0),
      expression: "moreThenOneHospital == 1 && !isOneHospital() && addNewOrEditData.extendData.hospitalInfos.length > 0"
    }],
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab"
    }, [_c('div', {
      staticClass: "field-row",
      class: _vm.required('extendData.hospitalInfos.' + index + '.hospitalLevelId', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && _vm.moreThenOneHospital == 1 && !_vm.isOneHospital())
    }, [_c('common-select', {
      attrs: {
        "tipCode": "9",
        "required": (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && _vm.moreThenOneHospital == 1 && !_vm.isOneHospital(),
        "clearable": "",
        "alignRight": "",
        "title": "医院层级",
        "placeholder": "请选择",
        "datas": _vm.filterHospitalLevel,
        "textKey": 'hospitalLevel',
        "valueKey": 'id'
      },
      model: {
        value: (hospital.hospitalLevelId),
        callback: function($$v) {
          _vm.$set(hospital, "hospitalLevelId", $$v)
        },
        expression: "hospital.hospitalLevelId"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field-row",
      class: _vm.required('extendData.hospitalInfos.' + index + '.hospitalCount', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && _vm.moreThenOneHospital == 1 && !_vm.isOneHospital())
    }, [_vm._m(7, true), _c('mt-field', {
      staticClass: "align-right",
      attrs: {
        "label": "",
        "placeholder": "请输入医院数量",
        "type": "number",
        "attr": {
          min: 0
        }
      },
      model: {
        value: (hospital.hospitalCount),
        callback: function($$v) {
          _vm.$set(hospital, "hospitalCount", $$v)
        },
        expression: "hospital.hospitalCount"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "operate-add-remove"
    }, [_c('i', {
      staticClass: "iconfont icon-shanjian",
      on: {
        "click": function($event) {
          return _vm.removeHosiptalInfo(index)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0')),
      expression: "(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')"
    }],
    staticClass: "field-block field-block-no-top-margin"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('offices', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && _vm.meetingSystemType != 'GSD')
  }, [_vm._v("科室(多选)"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('offices', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && _vm.meetingSystemType != 'GSD')
  }, [_c('common-select-multiple', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "title": "",
      "placeholder": "请选择",
      "datas": _vm.baseDataRecords.Office,
      "textKey": 'officeName',
      "valueKey": 'id'
    },
    model: {
      value: (_vm.addNewOrEditData.offices),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "offices", $$v)
      },
      expression: "addNewOrEditData.offices"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field-block field-block-no-top-margin"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('includeSpeaker', true)
  }, [_vm._v("是否包含讲者"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('mt-checklist', {
    staticClass: "radio",
    attrs: {
      "options": _vm.includeSpeakerOptions
    },
    model: {
      value: (_vm.includeSpeakerArray),
      callback: function($$v) {
        _vm.includeSpeakerArray = $$v
      },
      expression: "includeSpeakerArray"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.includeSpeaker == 1),
      expression: "addNewOrEditData.includeSpeaker == 1"
    }],
    staticClass: "field-block more-tab-block"
  }, [_c('div', {
    staticClass: "more-tab"
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('speakerLevel', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
  }, [_c('common-select', {
    attrs: {
      "tipCode": "10",
      "required": _vm.meetingSystemType != 'GSD',
      "clearable": "",
      "alignRight": "",
      "title": "讲者级别",
      "placeholder": "请选择",
      "datas": _vm.filterSpeakerLevel,
      "textKey": 'speakerLevel',
      "valueKey": 'id'
    },
    model: {
      value: (_vm.addNewOrEditData.speakerLevel),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "speakerLevel", $$v)
      },
      expression: "addNewOrEditData.speakerLevel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('speakerCount', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
  }, [_vm._m(8), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "label": "",
      "placeholder": "请输入人数",
      "type": "number",
      "attr": {
        min: 0
      }
    },
    model: {
      value: (_vm.addNewOrEditData.speakerCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "speakerCount", $$v)
      },
      expression: "addNewOrEditData.speakerCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-add-remove"
  }, [_c('i', {
    staticClass: "iconfont icon-tianjia1",
    on: {
      "click": _vm.AddNewSpeakerInfo
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab"
    }, [_c('div', {
      staticClass: "field-row",
      class: _vm.required('extendData.speakerInfos.' + index + '.speakerLevel', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
    }, [_c('common-select', {
      attrs: {
        "tipCode": "10",
        "required": _vm.meetingSystemType != 'GSD',
        "clearable": "",
        "alignRight": "",
        "title": "讲者级别",
        "placeholder": "请选择",
        "datas": _vm.filterSpeakerLevel,
        "textKey": 'speakerLevel',
        "valueKey": 'id'
      },
      model: {
        value: (speaker.speakerLevel),
        callback: function($$v) {
          _vm.$set(speaker, "speakerLevel", $$v)
        },
        expression: "speaker.speakerLevel"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field-row",
      class: _vm.required('extendData.speakerInfos.' + index + '.speakerCount', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
    }, [_vm._m(9, true), _c('mt-field', {
      staticClass: "align-right",
      attrs: {
        "label": "",
        "placeholder": "请输入人数",
        "type": "number",
        "attr": {
          min: 0
        }
      },
      model: {
        value: (speaker.speakerCount),
        callback: function($$v) {
          _vm.$set(speaker, "speakerCount", $$v)
        },
        expression: "speaker.speakerCount"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "operate-add-remove"
    }, [_c('i', {
      staticClass: "iconfont icon-shanjian",
      on: {
        "click": function($event) {
          return _vm.removeSpeakerInfo(index)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('attendCount', true)
  }, [_vm._m(10), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "label": "",
      "placeholder": "请输入人数",
      "type": "number",
      "attr": {
        min: 0
      }
    },
    model: {
      value: (_vm.addNewOrEditData.attendCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "attendCount", $$v)
      },
      expression: "addNewOrEditData.attendCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('rocheCount', _vm.meetingSystemType != 'GSD')
  }, [_vm._m(11), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "label": "",
      "placeholder": "请输入人数",
      "type": "number",
      "attr": {
        min: 0
      }
    },
    model: {
      value: (_vm.addNewOrEditData.rocheCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "rocheCount", $$v)
      },
      expression: "addNewOrEditData.rocheCount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row",
    class: _vm.required('totalAmount', true)
  }, [_c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("会议总预算 (CNY)"), _c('common-tooltip', {
    staticClass: "field-input-no-title-tooltip",
    attrs: {
      "tipCode": "12"
    }
  }), _c('span', [_vm._v("*")])], 1), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "label": "",
      "placeholder": "请输入金额",
      "disabled": _vm.disableTotalAmount
    },
    nativeOn: {
      "!blur": function($event) {
        return _vm.handleAmountCheck($event)
      }
    },
    model: {
      value: (_vm.addNewOrEditData.totalAmount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "totalAmount", $$v)
      },
      expression: "addNewOrEditData.totalAmount"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.meetingSystem.length == 2),
      expression: "addNewOrEditData.meetingSystem.length == 2"
    }],
    staticClass: "field-row",
    class: _vm.required('a1Amount', _vm.addNewOrEditData.meetingSystem.length == 2)
  }, [_vm._m(12), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "label": "",
      "placeholder": "请输入"
    },
    nativeOn: {
      "!blur": function($event) {
        return _vm.handleAmountCheck($event)
      }
    },
    model: {
      value: (_vm.addNewOrEditData.a1Amount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "a1Amount", $$v)
      },
      expression: "addNewOrEditData.a1Amount"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.meetingSystem.length == 2),
      expression: "addNewOrEditData.meetingSystem.length == 2"
    }],
    staticClass: "field-row",
    class: _vm.required('gsdAmount', _vm.addNewOrEditData.meetingSystem.length == 2)
  }, [_vm._m(13), _c('mt-field', {
    staticClass: "align-right",
    attrs: {
      "label": "",
      "placeholder": "请输入"
    },
    nativeOn: {
      "!blur": function($event) {
        return _vm.handleAmountCheck($event)
      }
    },
    model: {
      value: (_vm.addNewOrEditData.gsdAmount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "gsdAmount", $$v)
      },
      expression: "addNewOrEditData.gsdAmount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.required('costType', true)
  }, [_c('common-select', {
    attrs: {
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "类型",
      "placeholder": "请选择",
      "datas": _vm.costTypeOptions,
      "textKey": 'label',
      "valueKey": 'value'
    },
    on: {
      "change": _vm.handleCostTypeChange
    },
    model: {
      value: (_vm.addNewOrEditData.costType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costType", $$v)
      },
      expression: "addNewOrEditData.costType"
    }
  })], 1), _vm._v(" "), (_vm.addNewOrEditData.costType === '1') ? _c('div', {
    staticClass: "field-row",
    class: _vm.required('costCenter', _vm.addNewOrEditData.costType === '1')
  }, [_c('common-select', {
    attrs: {
      "filterable": "",
      "required": "",
      "clearable": "",
      "alignRight": "",
      "title": "成本中心",
      "placeholder": "请选择",
      "datas": _vm.costCenterData,
      "textKey": 'costCenterAndcostCenterName',
      "valueKey": 'costCenter',
      "specialTextKey": "specialText"
    },
    on: {
      "change": _vm.handleCostCenterChange
    },
    model: {
      value: (_vm.addNewOrEditData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costCenter", $$v)
      },
      expression: "addNewOrEditData.costCenter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.costType === '1') ? _c('div', {
    staticClass: "field-row"
  }, [_c('common-select', {
    attrs: {
      "clearable": "",
      "alignRight": "",
      "title": "Statistical WBS code",
      "placeholder": "请选择",
      "datas": _vm.wbsCodeData,
      "textKey": 'costId',
      "valueKey": 'costId'
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.costType === '2') ? _c('div', {
    staticClass: "field-row",
    class: _vm.required('wbsCode', _vm.addNewOrEditData.costType === '2')
  }, [_c('common-select', {
    attrs: {
      "clearable": "",
      "alignRight": "",
      "required": "",
      "title": "Real Wbs Code",
      "placeholder": "请选择",
      "datas": _vm.wbsCodeData,
      "textKey": 'costId',
      "valueKey": 'costId'
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('common-select-search', {
    attrs: {
      "clearable": "",
      "alignRight": "",
      "title": "会议申请人",
      "placeholder": "请选择申请人",
      "datas": _vm.remoteMeetingOrganizerData,
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "textKey": 'NameAndAd',
      "valueKey": 'Id'
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.meetingOrganizerName = _vm.getName(_vm.addNewOrEditData.meetingOrganizerId, _vm.remoteMeetingOrganizerData, 'Id', 'AD');
        _vm.addNewOrEditData.meetingOrganizerCnname = _vm.getName(_vm.addNewOrEditData.meetingOrganizerId, _vm.remoteMeetingOrganizerData, 'Id', 'CName');
      }
    },
    model: {
      value: (_vm.addNewOrEditData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingOrganizerId", $$v)
      },
      expression: "addNewOrEditData.meetingOrganizerId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary",
      "loading": false
    },
    on: {
      "click": _vm.handlerSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), (_vm.editType != 'edit') ? _c('mt-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "loading": false
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("删除")]) : _c('mt-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "loading": false
    },
    on: {
      "click": function($event) {
        return _vm.handleDeleteClick()
      }
    }
  }, [_vm._v("删除")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("会议名称"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("会议地点"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("受赠方名称"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("受赠方名称"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("受赠方名称"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("受赠方名称"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("医院数量"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("医院数量"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("讲者人数"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("讲者人数"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("参会者人数 (外)"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("罗氏员工人数 (内)"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("A1预算"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-input-no-title"
  }, [_vm._v("GSD预算"), _c('span', [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ddf5019", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ddf5019","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/meetingplan/application/edit/index.vue
// module id = 757
// module chunks = 7